module.exports = __webpack_public_path__ + "static/media/shisha-clear-animation.02c0095e.gif";